import LocalStore from '../lib/localStore'

const schema = {
  serverAddress: {
    type: 'string',
    default: '127.0.0.1',
  },
  darkMode: {
    type: 'boolean',
    default: false,
  },
  themeColor: {
    type: 'string',
    default: '#1976D2',
  },
  storeId: {
    type: 'string',
    default: 'a39bfc75-57ca-479f-b598-39e93ce19e7f',
  },
}

const store = new LocalStore({ schema })
const state = {
  darkMode: store.get('darkMode'),
  themeColor: store.get('themeColor'),
  serverAddress: store.get('serverAddress'),
  storeId: '',
}

const mutations = {
  SET_SERVER_ADDRESS(state, payload) {
    state.serverAddress = payload
  },
  SET_DARK_MODE(state, payload) {
    state.darkMode = payload
  },
  SET_THEME_COLOR(state, payload) {
    state.themeColor = payload
  },
  SET_STORE_ID(state, payload) {
    state.storeId = payload
  },
}

const actions = {
  setServerAddress({ commit }, payload) {
    store.set({ serverAddress: payload })
    commit('SET_SERVER_ADDRESS', payload)
  },
  setDarkMode({ commit }, payload) {
    store.set({ darkMode: payload })
    commit('SET_DARK_MODE', payload)
  },
  setThemeColor({ commit }, payload) {
    store.set({ themeColor: payload })
    commit('SET_THEME_COLOR', payload)
  },
  setStoreId({ commit }, payload) {
    store.set({ storeId: payload })
    commit('SET_STORE_ID', payload)
  },
}

export default {
  namespaced: true,
  strict: true,
  state,
  mutations,
  actions,
}
